import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import BareLayout from 'packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from 'packages/kakapo-ui-kit/components/forms/layouts/PublicForm';
import CenterHorizontal from 'packages/kakapo-ui-kit/components/atoms/CenterHorizontal';
import { SectionTitle, SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import { Button } from '@treams/treams-ui';
import { useHistory } from '@treams/treams-routes';

export default function InvalidNameID() {
    const { t } = useTranslation();
		const history = useHistory();

    return (
        <BareLayout>
            <Formik initialValues={{}} onSubmit={() => { }}>
                {() => (
                    <PublicForm>
                        <CenterHorizontal>
                            <SectionTitle>{t('common.errors.invalidNameID.title')}</SectionTitle>
                            <Box my={2} />
                            <SubSectionTitle>
                                {t('common.errors.invalidNameID.subtitle')}
                            </SubSectionTitle>
                            <Box my={4} />
                            <Paragraph>
                                {t('common.errors.invalidNameID.message')}
                            </Paragraph>
													  <Box my={4} />
														<Button
															title={t('common.homePage')}
															type="secondary"
															small
															onClick={() => {
																history.push('/')
															}}
														/>
                        </CenterHorizontal>
                    </PublicForm>
                )}
            </Formik>
        </BareLayout>
    );
}
